let config = {
    api_url : 'https://todo-orias.herokuapp.com'
}

export { config }